import { authApi } from "@/api/authApi";
import { authService } from "@/services/authService";
import { useUserStore } from "@/store/userStore";

export async function restoreAuthenticatedSession(): Promise<boolean> {
  const refreshed = await authService.refreshToken({ silent: true });

  if (!refreshed) {
    useUserStore.getState().clearUser();
    return false;
  }

  try {
    const user = await authApi.me();
    useUserStore.getState().setUser(user);
    return true;
  } catch {
    useUserStore.getState().clearUser();
    return false;
  }
}
